import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { Component, Children, cloneElement } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Grid from '../Grid';
import GridCol from '../GridCol';
import { safeInvoke } from '../utils';

var getNextSelectedValue = function getNextSelectedValue(value, prevValue, toggleable) {
  if (Array.isArray(prevValue)) {
    if (prevValue.indexOf(value) !== -1) {
      if (toggleable) {
        return prevValue.filter(function (v) {
          return v !== value;
        });
      }

      return prevValue;
    }

    return [].concat(_toConsumableArray(prevValue), [value]);
  }

  if (toggleable && prevValue === value) {
    return null;
  }

  return value;
};

/**
 * `ItemList` component is used for displaying list of [Items](#!/Item)
 * according to [Grid](#!/Grid) principle.
 * @since 0.0.48
 */
var ItemList =
/*#__PURE__*/
function (_Component) {
  _inherits(ItemList, _Component);

  function ItemList(_props) {
    var _this;

    _classCallCheck(this, ItemList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ItemList).call(this, _props)); // eslint-disable-next-line react/state-in-constructor

    _defineProperty(_assertThisInitialized(_this), "createItemProps", function (item) {
      var _this$props = _this.props,
          baseClassName = _this$props.baseClassName,
          selectable = _this$props.selectable,
          onSelect = _this$props.onSelect,
          reorderable = _this$props.reorderable;
      var classNameList = ["".concat(baseClassName, "__item")];
      var props = {};

      if (selectable && item.props.value !== undefined) {
        var _value = _this.state.value;
        var itemValue = item.props.value;

        if (Array.isArray(_value) && _value.indexOf(itemValue) !== -1) {
          classNameList.push("".concat(baseClassName, "__item--selected"));
        } else if (_value === itemValue) {
          classNameList.push("".concat(baseClassName, "__item--selected"));
        }

        props.onClick = function (e) {
          safeInvoke(item.props.onClick, e);
          var nextValue = getNextSelectedValue(itemValue, _value, selectable === 'toggleable' || selectable === 'multiple');

          _this.setState({
            value: nextValue
          });

          safeInvoke(onSelect, nextValue);
        };
      }

      if (reorderable) {
        classNameList.push("".concat(baseClassName, "__item--reorderable"));
      }

      classNameList.push(item.props.className);
      props.className = classNames.apply(void 0, classNameList);
      return props;
    });

    _this.state = {
      ReorderableGrid: null,
      ReorderableGridCol: null,
      value: typeof _props.defaultValue === 'undefined' ? null : _props.defaultValue
    };
    return _this;
  }

  _createClass(ItemList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var reorderable = this.props.reorderable;

      if (reorderable) {
        // @ts-ignore
        import(
        /* webpackChunkName: "react-sortable-hoc" */
        'react-sortable-hoc').then(function (_ref) {
          var sortableContainer = _ref.sortableContainer,
              sortableElement = _ref.sortableElement;

          _this2.setState({
            ReorderableGrid: sortableContainer(Grid),
            ReorderableGridCol: sortableElement(GridCol)
          });
        });
      }
    }
  }, {
    key: "renderNormal",
    value: function renderNormal(_ref2) {
      var _this3 = this;

      var baseClassName = _ref2.baseClassName,
          children = _ref2.children,
          props = _objectWithoutProperties(_ref2, ["baseClassName", "children"]);

      return React.createElement(Grid, props, Children.map(children, function (child) {
        return React.createElement(GridCol, {
          className: classNames("".concat(baseClassName, "__col"))
        }, cloneElement(child, _this3.createItemProps(child)));
      }));
    }
  }, {
    key: "hasViewCard",
    value: function hasViewCard() {
      var children = this.props.children;
      var result = false;
      Children.forEach(children, function (child) {
        if (child && child.props.view === 'card') {
          result = true;
        }
      });
      return result;
    }
  }, {
    key: "renderReorderable",
    value: function renderReorderable(_ref3) {
      var _classNames,
          _this4 = this;

      var baseClassName = _ref3.baseClassName,
          onReorderEnd = _ref3.onReorderEnd,
          children = _ref3.children,
          props = _objectWithoutProperties(_ref3, ["baseClassName", "onReorderEnd", "children"]);

      var _this$state = this.state,
          ReorderableGrid = _this$state.ReorderableGrid,
          ReorderableGridCol = _this$state.ReorderableGridCol;

      if (!ReorderableGrid) {
        return null;
      }

      var helperClass = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "__col--gap-xs"), props.gap === 'xs'), _defineProperty(_classNames, "".concat(baseClassName, "__col--gap-sm"), props.gap === 'sm'), _defineProperty(_classNames, "".concat(baseClassName, "__col--gap-md"), props.gap === 'md'), _defineProperty(_classNames, "".concat(baseClassName, "__col--gap-lg"), props.gap === 'lg'), _defineProperty(_classNames, "".concat(baseClassName, "__col--gap-xl"), props.gap === 'xl'), _classNames));
      return React.createElement(ReorderableGrid, _extends({
        axis: "xy",
        helperClass: helperClass,
        onSortEnd: onReorderEnd
      }, props), Children.map(children, function (child, index) {
        var disabled = child.props.disabled;
        return React.createElement(ReorderableGridCol, {
          index: index,
          className: classNames("".concat(baseClassName, "__col")),
          disabled: disabled
        }, cloneElement(child, _this4.createItemProps(child)));
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames2;

      var _this$props2 = this.props,
          className = _this$props2.className,
          reorderable = _this$props2.reorderable,
          hoverable = _this$props2.hoverable,
          stretchable = _this$props2.stretchable,
          selectable = _this$props2.selectable,
          onSelect = _this$props2.onSelect,
          value = _this$props2.value,
          defaultValue = _this$props2.defaultValue,
          onReorderEnd = _this$props2.onReorderEnd,
          props = _objectWithoutProperties(_this$props2, ["className", "reorderable", "hoverable", "stretchable", "selectable", "onSelect", "value", "defaultValue", "onReorderEnd"]);

      return React.createElement("div", {
        className: classNames(this.props.baseClassName, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(this.props.baseClassName, "--hoverable"), hoverable && !reorderable && !selectable), _defineProperty(_classNames2, "".concat(this.props.baseClassName, "--stretchable"), stretchable), _defineProperty(_classNames2, "".concat(this.props.baseClassName, "--selectable"), selectable), _defineProperty(_classNames2, "".concat(this.props.baseClassName, "--cards"), this.hasViewCard()), _classNames2), className)
      }, reorderable ? this.renderReorderable(_objectSpread({
        onReorderEnd: onReorderEnd
      }, props)) : this.renderNormal(props));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref4, state) {
      var selectable = _ref4.selectable,
          propValue = _ref4.value;

      if (selectable) {
        var multiple = selectable === 'multiple';
        var safeValue = multiple ? [] : null;

        var _value2 = typeof propValue === 'undefined' ? state.value : propValue;

        if (multiple && !Array.isArray(_value2)) {
          if (_value2) {
            return {
              value: [_value2]
            };
          }

          return {
            value: safeValue
          };
        } else if (!multiple && Array.isArray(_value2)) {
          if (_value2[0]) {
            return {
              value: _value2[0]
            };
          }

          return {
            value: safeValue
          };
        }

        return {
          value: _value2
        };
      }

      return null;
    }
  }]);

  return ItemList;
}(Component);

_defineProperty(ItemList, "defaultProps", {
  hoverable: true,
  stretchable: false,
  reorderable: false,
  selectable: false,
  baseClassName: "".concat(CLS_PREFIX, "item-list")
});

export default ItemList;